import React from 'react';
import { FaRegUser, FaEdit, FaSearchLocation, FaHandsHelping } from "react-icons/fa";

const steps = [
  {
    icon: <FaRegUser className="w-8 h-8" />,
    title: "Meet Our Expert",
    description: "We visit you to gather requirements and create detailed specifications.",
  },
  {
    icon: <FaEdit className="w-8 h-8" />,
    title: "Book with us",
    description: "Start your project by paying just 5% of the estimated cost.",
  },
  {
    icon: <FaSearchLocation className="w-8 h-8" />,
    title: "Track & Transact",
    description: "Pay in stages as construction progresses, with full transparency.",
  },
  {
    icon: <FaHandsHelping className="w-8 h-8" />,
    title: "Settle In",
    description: "We hand over your completed space, ready for you to move in.",
  },
];

const HowItWorks = () => {
  return (
    <div className="w-full py-24 px-4 flex justify-center items-center bg-white">
      <div className="w-full max-w-7xl">
        <h1 className="text-black text-3xl md:text-4xl text-center mb-14">How It Works</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 px-16">
          {steps.map((step, idx) => (
            <div key={idx} className="flex flex-col items-center text-center">
              <div className="w-16 h-16 flex justify-center items-center bg-black text-white rounded-full mb-4">
                {step.icon}
              </div>
              <h2 className="text-xl md:text-2xl font-semibold mb-4">{step.title}</h2>
              <p className="text-gray-700">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
